import { TimerService } from "./timer/timer.service";
import { BsModalRef } from "ngx-bootstrap/modal";
import { TimeTrackingDashboardComponent } from "./time-tracking-dashboard/time-tracking-dashboard.component";
import { JobTimeTrackingModalComponent } from "./job-time-tracking-modal/job-time-tracking-modal.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TimerComponent } from "./timer/timer.component";
import { StopTimerConfirmationModalComponent } from "./stop-timer-confirmation-modal/stop-timer-confirmation-modal.component";
import { TimeTrackingDetailsModalComponent } from "./time-tracking-details-modal/time-tracking-details-modal.component";
import { TableModule } from "primeng/table";
import { StartTimerFromPreviousEntryModalComponent } from "./start-timer-from-previous-entry-modal/start-timer-from-previous-entry-modal.component";
import { StartWithOngoingEntryModalComponent } from "./start-with-ongoing-entry-modal/start-with-ongoing-entry-modal.component";
import { DatePickerModule } from "primeng/datepicker";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { MomentModule } from "ngx-moment";
import { RouterModule } from "@angular/router";
import { DragulaModule } from "ng2-dragula";
import { TooltipModule } from "ngx-bootstrap/tooltip";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    DatePickerModule,
    BsDropdownModule,
    MomentModule,
    RouterModule,
    DragulaModule.forRoot(),
    TooltipModule.forRoot(),
    JobTimeTrackingModalComponent,
    TimerComponent,
    StopTimerConfirmationModalComponent,
    TimeTrackingDetailsModalComponent,
    TimeTrackingDashboardComponent,
    StartTimerFromPreviousEntryModalComponent,
    StartWithOngoingEntryModalComponent,
  ],
  exports: [TimerComponent],
  providers: [BsModalRef],
})
export class TimeTrackingModule {}
